interface HeaderProps {
	title: string;
	subtitle?: string;
}
export default function Header({ title, subtitle }: HeaderProps) {
	return (
		<div className="md:mb-8 mb-3">
			<div className="headline-2">{title}</div>
			{subtitle && <div className="caption">{subtitle}</div>}
		</div>
	);
}
